import { useIntl } from "react-intl";

export interface IMenuItem {
  id: number;
  link?: string;
  title: string;
  children?: IMenuItem[];
  external?: boolean;
}

export const useMenuItems = (): IMenuItem[] => {
  const { formatMessage } = useIntl();

  const home = formatMessage({ id: "components.header.menu.home" });
  const docs = formatMessage({ id: "components.header.menu.docs" });
  const pricing = formatMessage({ id: "components.header.menu.pricing" });
  const events = formatMessage({ id: "components.header.menu.events" });
  const company = formatMessage({ id: "components.header.menu.company" });
  const ourTeam = formatMessage({ id: "components.header.menu.ourTeam" });
  const technicalStack = formatMessage({ id: "components.header.menu.technicalStack" });
  const partnership = formatMessage({ id: "components.header.menu.partnership" });

  return [
    {
      id: 1,
      link: "/",
      title: home,
    },
    {
      id: 2,
      link: "https://dzambalaorg.github.io",
      title: docs,
      external: true,
    },
    {
      id: 3,
      link: "/pricing",
      title: pricing,
    },
    {
      id: 4,
      link: "/events",
      title: events,
    },
    {
      id: 5,
      title: company,
      children: [
        {
          id: 51,
          link: "/our-team",
          title: ourTeam,
        },
        {
          id: 52,
          link: "/technical-stack",
          title: technicalStack,
        },
        {
          id: 53,
          link: "/contact/partnership",
          title: partnership,
        },
      ],
    },
  ];
};
